import * as React from 'react';
import "./App.less";

import {baseDir} from './utils';
import {
    Navbar,
    Nav,
    NavItem,
} from 'react-bootstrap';
import {Router, Route, Link} from 'react-router-dom';

import createHashHistory from 'history/createHashHistory'
import {renderLexiconPageWithRoute} from "./components/LexiconPage";
import {renderMainPage, renderPublicationsPage, renderContributorsPage} from "./components/ExternalPage";
import {Footer} from "./components/Footer";
import {renderFramePageWithRoute} from "./components/FramePage";


import {Provider} from 'react-redux';
import {Actions, store} from "./reduxSetting";
import {renderSearchResultWithRoute, SearchBoxWithRouter} from "./components/search";
import {FrameMeta} from "./problem-domain/frame";
import {renderVerbIndexWithRouter} from "./components/VerbPage";
import {IndexLinkContainer} from 'react-router-bootstrap';
import {renderFrameIndexWithRouter} from "./components/FrameIndexPage";
import {FrameDropdownMenuRedux, DropdownSimple} from "./components/dropdown";
import * as DocumentTitle from 'react-document-title';
import {ProgramIndexWire, VersionWire} from "./bridge";
import {renderComparisonWithRoute} from "./components/compare-lexicons";

const customHistory = createHashHistory();

export class App extends React.Component<{}, { test: boolean }> {
    constructor(props) {
        super(props);
        this.state = {test: false};
    }

    componentDidMount() {
        store.dispatch(Actions.updateIndex(ProgramIndexWire.get()));
        store.dispatch(Actions.updateVersion(VersionWire.get()));
    }

    render() {
        return (
            <DocumentTitle title="Mandarin VerbNet">
                <Provider store={store}>
                    <Router history={customHistory}>
                        <div className="page-wrapper">
                            <div className="banner-wrapper">
                                <img src="banner.png" style={{"margin-left": "8%"}}/>
                            </div>
                            <Navbar>
                                <Navbar.Header>
                                    <Navbar.Brand>
                                        <Link to="/">Mandarin VerbNet</Link>
                                    </Navbar.Brand>
                                </Navbar.Header>
                                <Nav>
                                    <IndexLinkContainer to="/" activeClassName="active">
                                        <NavItem>Home</NavItem>
                                    </IndexLinkContainer>
                                    <DropdownSimple title={"Frames"}>
                                        <FrameDropdownMenuRedux bsRole="menu"/>
                                    </DropdownSimple>
                                    <IndexLinkContainer to="/verb-index" activeClassName="active">
                                        <NavItem>Verbs</NavItem>
                                    </IndexLinkContainer>
                                    <IndexLinkContainer to="/news" activeClassName="active">
                                        <NavItem>Publications</NavItem>
                                    </IndexLinkContainer>
                                    <IndexLinkContainer to="/contributors" activeClassName="active">
                                        <NavItem>Contributors</NavItem>
                                    </IndexLinkContainer>
                                    {/*<NavItem>Staff</NavItem>*/}
                                </Nav>
                                <SearchBoxWithRouter/>
                            </Navbar>
                            <div className="main-wrapper">
                                <Route exact path="/" render={renderMainPage}/>
                                <Route exact path="/news" render={renderPublicationsPage}/>
                                <Route exact path="/contributors" render={renderContributorsPage}/>
                                <Route path="/frame-index" render={renderFrameIndexWithRouter}/>
                                <Route path="/frame/:name" render={renderFramePageWithRoute}/>
                                <Route path="/verb-index" render={renderVerbIndexWithRouter}/>
                                <Route path="/lexicon/:name" render={renderLexiconPageWithRoute}/>
                                <Route path="/search/:keyword" render={renderSearchResultWithRoute}/>
                                <Route path="/comparison/:name" render={renderComparisonWithRoute}/>
                            </div>
                            <Footer/>
                        </div>
                    </Router>
                </Provider>
            </DocumentTitle>
        );
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx